import { render, staticRenderFns } from "./TimePickerAsSelect.vue?vue&type=template&id=4528cb2e&scoped=true"
import script from "./TimePickerAsSelect.vue?vue&type=script&lang=js"
export * from "./TimePickerAsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4528cb2e",
  null
  
)

export default component.exports